import React, { useEffect, useState } from "react";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";
import apiClient from "../../utils/apiClient";
import { numberToRupiah } from "../../utils/format";
import { useUser } from "../../pages/UserContext";
import RowActionsMenu from "../custom/RowActionsMenu";
import CustomButton from "../custom/CustomButton";
import CustomDataGrid from "../custom/CustomDataGrid";
import EditPengabdianModal from "./EditPengabdianModal";
import InsertPengabdianModal from "./InsertPengabdianModal";

export default function AbmasData() {
  const userDetails = useUser();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const [openInsertModal, setOpenInsertModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editTarget, setEditTarget] = useState({ userId: null, abmasId: null });

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `/abmas/details?isDeleted=0`;
        if (userDetails.role !== "admin") {
          url += `&lecturerId=${userDetails.uuid}`;
        }
        const response = await apiClient.get(url);
        setRows(
          response.data.data.map((abmas, index) => ({
            no: index + 1 + (page - 1) * 10,
            id: abmas.id,
            idDosen: abmas.id_dosen,
            namaAnggota: abmas.lecturer_name,
            kota: abmas.regency_name,
            mulaiPenelitian: abmas.tanggal_mulai,
            topik: abmas.topik,
            sumberBiaya: abmas.abmas_budget[0]?.sumber_biaya || "",
            budget: abmas.abmas_budget[0]
              ? numberToRupiah(abmas.abmas_budget[0].budget)
              : "",
            actual: abmas.abmas_budget[0]
              ? numberToRupiah(abmas.abmas_budget[0].actual)
              : "",
          }))
        );
      } catch (error) {
        console.error("Error fetching journals", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, refresh, userDetails.role, userDetails.uuid]);

  const handleAddAbmas = () => {
    setOpenInsertModal(true);
  };

  const handleInsertSuccess = () => {
    setOpenInsertModal(false);
    setRefresh((prev) => !prev);
  };

  const handleEditAbmas = (userId, abmasId) => {
    setEditTarget({ userId, abmasId });
    setOpenEditModal(true);
  };

  const handleEditSuccess = () => {
    setOpenEditModal(false);
    setRefresh((prev) => !prev);
  };

  const handleDeleteAbmas = async (abmasId) => {
    Swal.fire({
      text: "Kamu akan menghapus pengabdian ini",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiClient.post(`/abmas/delete`, { id: abmasId });
          showSuccessToast(response.data.msg);
          setRefresh(!refresh);
        } catch (error) {
          console.error("Error deleting abmas", error);
          showErrorToast("There was an error deleting abmas.");
        }
      }
    });
  };

  const columns = [
    { field: "no", headerName: "No.", flex: 1 },
    { field: "namaAnggota", headerName: "Nama Anggota", flex: 1 },
    { field: "kota", headerName: "Kota", flex: 1 },
    {
      field: "mulaiPenelitian",
      headerName: "Mulai Penelitian",
      flex: 1,
    },
    { field: "topik", headerName: "Topik", flex: 1 },
    { field: "sumberBiaya", headerName: "Sumber Biaya", flex: 1 },
    { field: "budget", headerName: "Budget", flex: 1, minWidth: 160 },
    { field: "actual", headerName: "Actual", flex: 1, minWidth: 160 },
    {
      field: "actions",
      headerName: "Action",
      renderCell: (params) => (
        <RowActionsMenu
          actions={[
            {
              label: "Edit",
              onClick: () => handleEditAbmas(params.row.idDosen, params.row.id),
            },
            {
              label: "Hapus",
              onClick: () => handleDeleteAbmas(params.row.id),
              danger: true,
            },
          ]}
        />
      ),
      flex: 1,
    },
  ];

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <CustomButton
        onClick={handleAddAbmas}
        text="Tambah Pengabdian"
        isFullWidth={false}
        baseColor="#003158"
        hoverColor="#00213A"
      />
      <br></br>
      <CustomDataGrid
        rows={rows}
        columns={columns}
        setPage={setPage}
        loading={loading}
      />
      <EditPengabdianModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        userId={editTarget.userId}
        abmasId={editTarget.abmasId}
        onSuccess={handleEditSuccess}
      />
      <InsertPengabdianModal
        open={openInsertModal}
        onClose={() => setOpenInsertModal(false)}
        onSuccess={handleInsertSuccess}
      />
    </div>
  );
}
